import { NotItems } from "component/basic/notItems";
import { setDateTime } from "js/function";
import { useNavigate } from "react-router-dom";

function MainDataSection(data){
    return (
        <div className={`mainDataSection ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}

function MainDataArea(data){
    return (
        <div className={`mainDataArea ${data.addClass||""}`}>
            {data.children}
        </div>
    );
}


function MainBgItem(data){
    return (
        <div className={`mainBgItem backgroundImg ${data.addClass||""}`} style={{backgroundImage:`url('${data.img}')`}}/>
    );
}

function MainDataTitleBox(data){
    return (
        <div className={`mainDataTitleBox ${data.addClass||""}`}>
            <h1 className="mainDataTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
            <p className="mainDataSubTitle" dangerouslySetInnerHTML={{__html:data.subTitle}}/>
        </div>
    );
}

function MainCsItemBox(data){
    let navigate = useNavigate();

    return (
        <div className={`mainCsItemBox ${data.addClass||""}`}>
            <button type="button" onClick={()=>{data.func()}} className="mainCsItem_title">{data.title}<img src="/assets/images/basic/move_w.svg"/></button>
            <div className="mainCsItemListBox">
                {data.data && data.data?.length > 0 ? 
                    <>{data?.data && data?.data?.map((item,i)=>(
                        <button type="button" key={i} onClick={()=>{
                            if(data.type === "faq"){
                                sessionStorage.setItem("faqOpen",item.id);
                                navigate("/faq");
                            }else{
                                navigate(`/notice/detail/${item.id}`);
                            }
                        }} className="mainCsItemList">
                            <h2 className="mainCsItemList_title" dangerouslySetInnerHTML={{__html:item.title}}/>
                            <p className="mainCsItemList_text" dangerouslySetInnerHTML={{__html:data.type === "faq" ? `#${item.category}` : setDateTime(item.created_at,"dayyymmddhh",null)}}/>
                        </button>
                    ))}</>
                :
                <NotItems text={`${data.title}이 없습니다.`}/>}
            </div>
        </div>
    );
}

export {MainDataSection,MainDataArea,MainDataTitleBox,MainCsItemBox,MainBgItem}